import { SharesTitle, Transaction, Partner } from 'types';

export const getTitleByTransaction = (
  sharesTitles: SharesTitle[],
  transaction: Transaction
) =>
  sharesTitles?.find(
    (title: SharesTitle) =>
      title?.operation === transaction?.operation &&
      title?.partners?.some(
        (partner: Partial<Partner>) => partner._id === transaction?.partner
      )
  );
